// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageEditedMarker-modulechatroomMessageEditedMarker__icno0";
export { _1 as "chatroomMessageEditedMarker" }
